import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import CollectiveReel from "./CollectiveReel";
import DirectorsLanding from "./DirectorsLanding";
import Clients from "./Clients";
import Biography from "./Biography";
import Contact from "./Contact";
import "../styles/Site.scss";
import ArtistsDetail from "./ArtistsDetail";
import ScrollToTop from "./ScrollToTop";
import Reel2020 from "./Reel2020";
import Reel2021 from "./Reel2021";
import About from "./About";
import CollectiveReels from "./CollectiveReels";
import PhotographersLanding from "./PhotographersLanding";

function App() {
  return (
    <Router basename={`/`}>
      <ScrollToTop />
      <Switch>
        <Route
          path={`${process.env.PUBLIC_URL}/collective-reel`}
          exact
          component={CollectiveReel}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/reel-2021`}
          exact
          component={Reel2021}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/reel-2020`}
          exact
          component={Reel2020}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/artists/directors`}
          exact
          render={(props) => (
            <DirectorsLanding
              title="Film &amp; Content"
              json="film"
              {...props}
            />
          )}
        />{" "}
        <Route
          path={`${process.env.PUBLIC_URL}/collective-reels`}
          exact
          component={CollectiveReels}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/artists/photographers`}
          exact
          render={(props) => (
            <PhotographersLanding
              title="Photography"
              json="photographers"
              {...props}
            />
          )}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/clients`}
          exact
          component={Clients}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/biography`}
          exact
          component={Biography}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/contact`}
          exact
          component={Contact}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/artists/:type/:id`}
          render={(props) => <ArtistsDetail {...props} />}
        />
        <Redirect to="/artists/directors" />
      </Switch>
    </Router>
  );
}

export default App;
